import { render, staticRenderFns } from "./EmployeesNew.vue?vue&type=template&id=079b2384&scoped=true"
import script from "./EmployeesNew.vue?vue&type=script&lang=js"
export * from "./EmployeesNew.vue?vue&type=script&lang=js"
import style0 from "./EmployeesNew.vue?vue&type=style&index=0&id=079b2384&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079b2384",
  null
  
)

export default component.exports